/**
 * Shows whether a track has been loudness-scanned (normalized on ingest).
 */
import { Volume2, VolumeX } from "lucide-react";
import type { Track } from "@memes/shared";

interface Props {
  track: Pick<Track, "loudnessGainDb">;
  className?: string;
}

export const LoudnessIndicator: React.FC<Props> = ({ track, className = "" }) => {
  const normalized = track.loudnessGainDb != null;
  return (
    <span
      className={`inline-flex items-center gap-0.5 rounded-md px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide ${
        normalized
          ? "bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-200"
          : "bg-gray-100 text-gray-500 dark:bg-gray-800 dark:text-gray-400"
      } ${className}`}
      title={
        normalized
          ? `Loudness normalized (${track.loudnessGainDb!.toFixed(1)} dB gain)`
          : "Not loudness-scanned yet"
      }
    >
      {normalized ? (
        <Volume2 className="h-3 w-3" aria-hidden />
      ) : (
        <VolumeX className="h-3 w-3" aria-hidden />
      )}
      {normalized ? "Norm" : "Raw"}
    </span>
  );
};
